import React from 'react';
import { Select, MenuItem, Box, FormControl, InputLabel } from '@mui/material';
import { timeZones } from 'components/constants';

interface TimezoneSelectorProps {
  timezone: string;
  onChange: (timezone: string) => void;
  useFormControl?: boolean;
  size?: 'small' | 'medium';
  required?: boolean;
}

const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({ timezone, onChange, useFormControl = false, size = 'small', required = false }) => {
  if (useFormControl) {
    return (
      <FormControl fullWidth required={required}>
        <InputLabel id="timezone-label">Timezone</InputLabel>

        <Select
          fullWidth
          labelId="timezone-label"
          label="Timezone"
          size={size}
          onChange={e => onChange(e.target.value as string)}
          value={timezone || Intl.DateTimeFormat().resolvedOptions().timeZone}
        >
          {timeZones.map(timezone => (
            <MenuItem key={timezone} value={timezone}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>{timezone.replace(/_/g, ' ')}</Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <Select
      fullWidth
      size={size}
      onChange={e => onChange(e.target.value as string)}
      value={timezone || Intl.DateTimeFormat().resolvedOptions().timeZone}
    >
      {timeZones.map(timezone => (
        <MenuItem key={timezone} value={timezone}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>{timezone.replace(/_/g, ' ')}</Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default TimezoneSelector;
